const ROLE_ROUTE_MAP = {
  CM: "/warehouses",
  SP: "/tables",
  BK: "/marketingdataanalysis",
  MN: "/marketingdataanalysis",
};

const DEFAULT_ROUTE = "/marketingdataanalysis";

const getDefaultPathByRole = (roleValue) => ROLE_ROUTE_MAP[roleValue] || DEFAULT_ROUTE;

export default getDefaultPathByRole;
